import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import AwairPage from './components/pages/AwairPage';
import LegalPage from './components/pages/LegalPage';

class App extends Component {
  componentDidMount() {
    ReactGA.pageview(`${window.location.pathname}${window.location.search}`);
    ReactPixel.pageView();
  }

  render() {
    return (
      <Switch>
        <Route exact path='/' component={AwairPage} />
        <Route path='/pages/legal' component={LegalPage} />
      </Switch>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/app/App.js